module.exports = __webpack_public_path__ + "img/booking-closed.9cd0c800.svg";